<template>
  <v-card class="px-3 pt-2">
    <v-row align="center">
      <v-toolbar-title class="py-2 pl-3">
        {{ label }}
      </v-toolbar-title>
      <v-divider
        class="mx-3"
        vertical
      />
      <v-tooltip
        top
        color="#388e3c"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="primary-button py-2"
            :disabled="disabled"
            :loading="loading"
            v-on="{ on }"
            @click="$emit('update-report')"
          >
            Сформувати
          </v-btn>
        </template>

        <span>Оновити звіт</span>
      </v-tooltip>
      <slot name="header-filter" />
      <v-spacer />
      <v-col
        v-if="$slots.action"
        cols="4"
        class="d-flex flex-row-reverse"
      >
        <slot name="action" />
      </v-col>
    </v-row>
    <v-row
      v-if="$slots.filters"
      class="pl-0"
    >
      <v-col class="pl-3 py-1">
        <slot name="filters" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    loading: { type: Boolean, default: false },
    disabled: Boolean,
  },
};
</script>

<style>
.v-toolbar__title {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>